import { render } from "./ChristmasPopup.vue?vue&type=template&id=6aae3092"
import script from "./ChristmasPopup.vue?vue&type=script&lang=js"
export * from "./ChristmasPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__